"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const QwilrPayGreyscale = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "23", viewBox: "0 0 24 23", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement("circle", { cx: 11.8906, cy: 11.3906, r: 11.0399, fill: "#8790A6", stroke: "#E0E8F1", strokeWidth: 0.279492 }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        opacity: 0.7,
        d: "M7.58393 14.0633L7.16748 13.5469C6.85931 13.7051 6.50116 13.7884 6.12635 13.7884C4.70209 13.7884 3.71094 12.6723 3.71094 11.1481C3.71094 9.61557 4.70209 8.50781 6.12635 8.50781C7.55061 8.50781 8.5501 9.61557 8.5501 11.1481C8.5501 11.9061 8.2919 12.5557 7.85879 13.0305L8.26691 13.5302L7.58393 14.0633ZM7.47565 11.1481C7.47565 10.1486 6.9426 9.45732 6.12635 9.45732C5.31844 9.45732 4.79371 10.1486 4.79371 11.1481C4.79371 12.1476 5.31844 12.8639 6.12635 12.8639C6.2846 12.8639 6.43453 12.8472 6.56779 12.8056L6.15134 12.2809L6.83432 11.7561L7.23411 12.2559C7.39236 11.981 7.47565 11.6145 7.47565 11.1481Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M18.0396 15.0895H17.0235L17.5649 13.7319L16.1406 9.99219H17.2317L18.0896 12.4659L18.9392 9.99219H19.9803L18.0396 15.0895Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M16.0316 13.7126H15.0405V13.5127C14.9155 13.6376 14.5407 13.7792 14.1326 13.7792C13.383 13.7792 12.75 13.3461 12.75 12.5715C12.75 11.8636 13.383 11.3805 14.1909 11.3805C14.5158 11.3805 14.8906 11.4888 15.0405 11.597V11.3222C15.0405 11.0057 14.8489 10.7475 14.4325 10.7475C14.1409 10.7475 13.966 10.8807 13.8827 11.0973H12.8999C13.0082 10.4226 13.6162 9.90625 14.4658 9.90625C15.4569 9.90625 16.0316 10.4476 16.0316 11.3388V13.7126ZM15.0405 12.6965V12.4299C14.9489 12.23 14.6657 12.1051 14.3658 12.1051C14.041 12.1051 13.7078 12.2467 13.7078 12.5632C13.7078 12.888 14.041 13.0213 14.3658 13.0213C14.6657 13.0213 14.9489 12.8964 15.0405 12.6965Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M10.9416 11.9337H9.91716V13.7078H8.85938V8.59375H10.9416C12.0244 8.59375 12.7407 9.17678 12.7407 10.2679C12.7407 11.3507 12.0244 11.9337 10.9416 11.9337ZM11.6912 10.2679C11.6912 9.80979 11.4247 9.50161 10.875 9.50161H9.91716V11.0258H10.875C11.4247 11.0258 11.6912 10.7093 11.6912 10.2679Z",
        fill: "white"
      }
    )
  );
};
export default QwilrPayGreyscale;
